<template>
	<div class="control-group" :class="{filled: option, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" @click="open()" v-html="label">{{ label }}<span v-if="required">*</span></label>
			<div class="input" :class="{'has-append': appendIcon}">
				<div class="input-holder">
					<v-multiselect 
						@select="handleSelect"
						@remove="option = null"
						:value="option"
						:disabled="disabled"
						:options="options" 
						:multiple="false" 
						:label="optionText" 
						:track-by="optionValue" 
						placeholder=""
						@open="focused = true"
						@close="focused = false"
						@search-change="$emit('search', $event)"
						ref="input"
					></v-multiselect>
			    </div>
		    	<span v-if="appendIcon" @click.prevent="$emit('click:append')" class="append-icon"><i class="material-icons">{{ appendIcon }}</i></span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	export default {
		props: ['value', 'label', 'errors', 'required', 'placeholder', 'disabled', 'appendIcon', 'autocomplete', 'readonly', 'options', 'optionText', 'optionValue'],
		data() {
			return {
				option: this.value,
				focused: false
			}
		},
		methods: {
			handleSelect(selectedOption, id){
				this.option = JSON.parse(JSON.stringify(selectedOption));
			},
			open() {
				if(this.disabled) {
					return;
				}
				this.$refs.input.toggle();
			}
		},
		watch: {
			option() {
				this.$emit('input', this.option);
			},
			value() {
				this.option = this.value;
			}
		}
	}
</script>